// ConfigInputs.js
import ConfigTab from "./ConfigTab";
import { buttonText } from "../../../utils/buttonText";

function ConfigInputs(props) {
  const { item, config, setConfig } = props;

  return (
    <div className="config-inputs">
      <nav>
        <div className="nav nav-tabs" id={`nav-tab-${item.title}`} role="tablist">
          {Object.keys(config).map((tab, index) => {
            const isSelected = tab === "Common";
            return (
              <button
                key={`${item.title}-${index}`}
                className={`nav-link${tab === "Common" ? " active" : ""}`}
                id={`nav-${tab}-${item.title}-tab`}
                data-bs-toggle="tab"
                data-bs-target={`#nav-${tab}-${item.title}`}
                type="button"
                role="tab"
                aria-controls={`nav-${tab}-${item.title}`}
                aria-selected={isSelected}
              >
                {buttonText(tab)}
              </button>
            );
          })}
        </div>
      </nav>
      <div className="tab-content" id="nav-tabContent">
        {Object.keys(config).map((tab) => (
          <ConfigTab key={`${item.title}-${tab}`} item={item} tab={tab} config={config} setConfig={setConfig} />
        ))}
      </div>
    </div>
  );
}

export default ConfigInputs;
